import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Button from 'components/field/Button';
import FormHeader from 'components/global/FormHeader';
import Loading from 'components/global/Loading';

import { PLATFORM } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import ConnectSalesChannelModal from './ConnectSalesChannelModal';
import * as S from './SalesChannelDetail.styled';
import SalesChannelDetailContent from './SalesChannelDetailContent';
import useAuthorize from './Stores/useAuthorize';
import { getOnlineStoreBySlug } from './salesChannelDetailsSlice';

const HIDE_CONNECT_BUTTON_CHANNELS = ['zid', 'salla', 'bigcommerce'];

const SalesChannelDetail = () => {
	const { slug } = useParams();
	const dispatch = useDispatch();
	const { salesChannel, loading } = useSelector((state) => state.salesChannel);
	const { authorizeLoading } = useAuthorize();
	const isLoading = useMemo(
		() => authorizeLoading || loading || !salesChannel,
		[authorizeLoading, loading, salesChannel]
	);

	useEffect(() => {
		dispatch(getOnlineStoreBySlug(slug));
	}, [slug]);

	const handleConnectStore = () => {
		NiceModal.show(ConnectSalesChannelModal);
	};

	if (isLoading) return <Loading />;

	return (
		<div>
			<S.Header>
				<FormHeader
					lightTitle="backToSalesChannels"
					boldTitle={`salesChannel.${salesChannel?.integrationName}`}
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.SALES_CHANNELS, PATHS.ONLINE_STORES)}
				/>
				{salesChannel?.slug === 'salla-desktop' && import.meta.env.VITE_PLATFORM === PLATFORM.web ? (
					<Button
						label="downloadDesktopApp"
						icon={faDownload}
						variant="outline"
						onClick={() => window.open('https://tryoto.com/apps', '_blank', 'noopener,noreferrer')}
						loading={isLoading}
						size="large"
					/>
				) : (
					salesChannel &&
					!HIDE_CONNECT_BUTTON_CHANNELS.includes(salesChannel.slug) && (
						<Button label="connectStore" onClick={handleConnectStore} />
					)
				)}
			</S.Header>

			<SalesChannelDetailContent />
		</div>
	);
};

export default SalesChannelDetail;
